module.exports = __webpack_public_path__ + "img/mydz@2x.bce7bd94.png";